import React from 'react';
import ApplicationsTableView from '../../views/applications/table';
import UUID from 'uuid';
import gql from 'nanographql';
import { getHeaders } from '../../services/fetch';
import { APP_GRAPHQL } from '../../services/config';
import { withRouter } from 'react-router-dom';
import { AppCollection } from '../../services/collection';

const DELETE_APP = gql`
mutation removeApp($uuid: UUID!) {
  removed: removeApp(uuid: $uuid)
}
`;

class ApplicationsTableScreen extends React.Component {

  onSave = async ({ versions, instances, ...data }, setData) => {
    const input = {
      ...data,
      uuid: data.uuid || UUID.v4()
    };
    await AppCollection.actions.save(input);
    await setData({
      versions,
      instances,
      ...input
    });
  };

  onDelete = async (data, remove) => {
    if (!data.uuid) {
      return remove();
    }
    const body = DELETE_APP({
      uuid: data.uuid
    });
    const response = await fetch(
      APP_GRAPHQL,
      {
        method: 'POST',
        body,
        headers: {
          ...getHeaders(),
          'Content-Type': 'application/json'
        }
      }
    );
    const { data: result } = await response.json();
    if (!result) {
      return alert('Failed to save value');
    }
    await remove(data.uuid);
  };

  onPermissions = data => {
    this.props.history.push(`/applications/${data.uuid}/permissions`, {
      data
    });
  };

  onVersions = data => {
    this.props.history.push(`/applications/${data.uuid}/versions`, {
      data
    });
  };

  onInstances = data => {
    this.props.history.push(`/applications/${data.uuid}/instances`, {
      data
    });
  };

  render() {
    return (
      <ApplicationsTableView
        products={this.props.apps || []}
        onSave={this.onSave}
        onDelete={this.onDelete}
        onPermissions={this.onPermissions}
        onInstances={this.onInstances}
        onVersions={this.onVersions}
      />
    )
  }
}

const mapAppProps = ({ loading, list }) => ({ apps: list, appsLoading: loading });

const appConnect = AppCollection.connect(mapAppProps);

export default appConnect(
  withRouter(ApplicationsTableScreen)
);



// WEBPACK FOOTER //
// ./src/app/applications/table.js